import React from "react";
import { useTranslation } from "react-i18next";
import imgFeatures from "../../../assets/images/home/page2.webp";
import imgFeaturesZh from "../../../assets/images/home/page2_zh.webp";
import "./Features.css";

const Features = () => {
  const { t, i18n } = useTranslation();
  const isZh = i18n.language?.startsWith("zh");
  const points = t("home.features.points", { returnObjects: true });

  return (
    <section className="features-wrapper">
      <div className="features-container">
        {/* Left Side: Content */}
        <div className="features-content">
          <h2 className="features-title global-title">{t("home.features.title")}</h2>
          <p className="features-subtitle global-subtitle">{t("home.features.subtitle")}</p>

          <ul className="features-list">
            {Array.isArray(points) && points.map((point, index) => (
              <li key={index} className="feature-point global-text">
                {point}
              </li>
            ))}
          </ul>
        </div>

        {/* Right Side: Image */}
        <div className="features-visual">
          <img src={isZh ? imgFeaturesZh : imgFeatures} alt="IKI AI App Features" className="features-main-img" />
        </div>
      </div>
    </section>
  );
};

export default Features;
